module.exports = __webpack_public_path__ + "img/LH-make-graphic-hero-right.c9f87352.svg";